import React, { useState } from "react";

function Select({ response, onChange }) {
  const [value, setValue] = useState(response.value);
  
  return (
    <div className="form-group">
      <div className="row">
        <select
          className="form-control"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
        >
          {response.element.properties.options.map((_option, i) => (
            <option value={_option} key={i}>
              {_option}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default Select;
